import React from 'react'

// |-- External Dependencies --|
import { ErrorMessage } from 'formik'

// |-- Internal Dependencies --|
type SelectOption = {
    label: string
    value: string | number
}

// |-- Types --|
export type Props = {
    name: string
    options: SelectOption[]
    label?: string
    value: string | string[] | number
    required?: boolean
    className?: string
    onChange: (e: string) => void
    isSubmitting?: boolean
}

const ATMRadioButton = ({
    value,
    required = false,
    name,
    options,
    label,
    className = 'mt-2',
    onChange,
    isSubmitting = true,
}: Props) => {
    return (
        <div className="relative   w-full">
            {label && (
                <label className="text-slate-700 font-medium">
                    {label}
                    {required && <span className="text-red-500"> * </span>}
                </label>
            )}

            <div
                className={`lg:flex  ${className} w-full py-2 pr-2 gap-12`}
            >
                {options.map((option: SelectOption, index) => (
                    <div
                        onChange={() => {
                            onChange(option.value as string)
                        }}
                        key={index}
                        className={`${index === 0 ? '' : ''
                            } text-[17px] text-base  `}
                    >
                        <input
                            type="radio"
                            className='cursor-pointer'
                            name={name}
                            value={value}
                            checked={option.value === value}
                            onChange={() => { }}
                        />
                        <label
                            onClick={() => {
                                onChange(option.value as string)
                            }}
                            className="ml-1 text-[18px] text-base  cursor-pointer font-medium"
                        >
                            {option.label}
                        </label>
                    </div>
                ))}
            </div>
            {name && isSubmitting && (
                <ErrorMessage name={name}>
                    {(errMsg) => (
                        <p className="font-poppins absolute text-[14px] text-start mt-0 text-red-500 py-1 mb-1">
                            {errMsg}
                        </p>
                    )}
                </ErrorMessage>
            )}
        </div>
    )
}

export default ATMRadioButton